import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

const Single_product_skeleton = () => {
    return (
        <>

            {/* <div id="preloader"></div> */}
          <div className='single_product_section'>
                <Container fluid>
                    <Row>
                        <Col md={6}>
                            <Row className='mobile_hide'>
                                <Col md={6} className='pe-0 m-auto mb-2'>
                                    <Skeleton height={400} />
                                </Col>
                                <Col md={6} className='pe-0 m-auto mb-2'>
                                    <Skeleton height={400} />
                                </Col>
                                <Col md={6} className='pe-0 m-auto mb-2'>
                                    <Skeleton height={400} />
                                </Col>
                                <Col md={6} className='pe-0 m-auto mb-2'>
                                    <Skeleton height={400} />
                                </Col>
                            </Row>
                            <Col md={6} className='desktop_hide'>
                                    <Skeleton height={300} />
                                </Col>
                        </Col>
                        <Col md={6}>
                            <Skeleton height={45} count={2} className='mobile_hide'/>
                            <Skeleton height={25} count={2} className='desktop_hide'/>
                            <Skeleton height={40} width={400} className='mt-4 mb-4 mobile_hide' />
                            <Skeleton height={20} className='mt-2 mb-2 desktop_hide' />
                            <Skeleton height={45} count={2} className='mobile_hide'/>
                            <Skeleton height={25} count={2} className='desktop_hide'/>
                            <Skeleton height={40} width={400} className='mt-4 mobile_hide' />
                            <Skeleton height={20} className='mt-2 desktop_hide' />
                            <div className='d-flex mt-2'>
                                <div className='me-2'>
                                    <Skeleton height={60} width={60} />
                                </div>
                                <div className='me-2'>
                                    <Skeleton height={60} width={60} />
                                </div>
                                <div className='me-2'>
                                    <Skeleton height={60} width={60} />
                                </div>
                                <div className='me-2'>
                                    <Skeleton height={60} width={60} />
                                </div>
                            </div>
                            <Skeleton height={40} width={400} className='mt-4 mobile_hide' />
                            <Skeleton height={20} className='mt-2 desktop_hide' />
                            <div className='d-flex mt-2'>
                                <div className='me-2'>
                                    <Skeleton className="rounded-circle" height={60} width={60} />
                                </div>
                                <div className='me-2'>
                                    <Skeleton className="rounded-circle" height={60} width={60} />
                                </div>
                                <div className='me-2'>
                                    <Skeleton className="rounded-circle" height={60} width={60} />
                                </div>
                                <div className='me-2'>
                                    <Skeleton className="rounded-circle" height={60} width={60} />
                                </div>
                            </div>
                            <Row className='mt-4'>
                                <Col md={6}>
                                    <Skeleton height={40} />
                                    <Skeleton height={50} />
                                </Col>
                                <Col md={6}>
                                    <Skeleton height={40} />
                                    <Skeleton height={50} />
                                </Col>
                            </Row>
                            <Skeleton height={50} width={400} className='mt-4 mobile_hide' />
                            <Skeleton height={30} className='mt-2 desktop_hide' />
                            {/* <Skeleton height={500} className='mt-4 mb-4' /> */}
                        </Col>
                    </Row>
                </Container>
            </div> 

        </>
    )
}

const Single_product_ring_skeleton = () => {
    return (
        <></>
        // <Container fluid className='text-center'>
        //     <Row className='mt-4'>
        //         <Col md={3}>
        //             <Skeleton height={300} />
        //             <Skeleton height={40} count={2} width={300} />
        //             <Skeleton height={40} width={200} />
        //         </Col>
        //         <Col md={3}>
        //             <Skeleton height={300} />
        //             <Skeleton height={40} count={2} width={300} />
        //             <Skeleton height={40} width={200} />
        //         </Col>
        //         <Col md={3}>
        //             <Skeleton height={300} />
        //             <Skeleton height={40} count={2} width={300} />
        //             <Skeleton height={40} width={200} />
        //         </Col>
        //         <Col md={3}>
        //             <Skeleton height={300} />
        //             <Skeleton height={40} count={2} width={300} />
        //             <Skeleton height={40} width={200} />
        //         </Col>
        //     </Row>
        // </Container>
    )
}


export { Single_product_skeleton, Single_product_ring_skeleton }